import {
    madnes_get_angle,
    madnes_get_pos_y,
    madnes_set_angle,
    madnes_set_pos_y
} from "../framework/src/engine/madnes/madnes_object";
import {to_degrees, to_radians} from "./helpers";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";

/**
 * @constructor
 * @param {string} name
 * @param {number} length
 * @param {number} velocity
 * @param {number=} delay
 * @returns {AnimPendulumSine}
 */
export function AnimPendulumSine(name, length, velocity, delay) {

    this._name = name;

    this._iniAngleRad = to_radians(madnes_get_angle(this._name));
    this._angleRad = 0;

    this._len = typeof length !== 'undefined' ? length : 1;
    this._velocity = typeof velocity !== 'undefined' ? velocity : 0.05;

    this._delay = typeof delay !== 'undefined' ? delay : 0;

    this._upd = this._update.bind(this);
};

AnimPendulumSine.prototype._update = function() {
    this._angleRad += this._velocity;

    var rad = Math.sin(this._angleRad) * this._len + this._iniAngleRad;
    madnes_set_angle(this._name, to_degrees(rad));
};

AnimPendulumSine.prototype.run = function() {
    var _self = this;

    setTimeout(function() {
        madnes_add_to_render(_self._upd);
    }, this._delay);
};

AnimPendulumSine.prototype.stop = function() {
    madnes_rem_from_render(this._upd);
};

/**
 * @constructor
 * @param {string} name
 * @param {number} length
 * @param {number} velocity
 * @returns {AnimSineBouncingY}
 */
export function AnimSineBouncingY(name, length, velocity) {

    this._name = name;
    this._angleRad = 0;
    this._lastSin = null;
    this._len = length;
    this._velocity = velocity;
    this._origPosY = madnes_get_pos_y(name);

    this.upd = this._update.bind(this);

    this.onPI = function() {};
    this.on2PI = function() {};
    this.onHalfPI = function() {};
    this.on3QPI = function() {};
};

/** @param {number} l */
AnimSineBouncingY.prototype.setLen = function(l) {
    this._len = l;
};

/** @param {number} v */
AnimSineBouncingY.prototype.setVelocity = function(v) {
    this._len = v;
};

AnimSineBouncingY.prototype._update = function() {

    if(this._angleRad === 0) {
        madnes_audio_play('misc_Rope_Right');
    }

    this._angleRad += this._velocity;
    var sin = Math.sin(this._angleRad);
    //var nextSyn = Math.sin(this.angle + this.velocity);
    var posY = this._len * sin + this._origPosY;

    if(this._lastSin >= 0 && sin < 0) {

        this.onPI();
        madnes_audio_play('misc_Rope_Left');

    } else if(this._lastSin < 0 && sin >= 0) {

        this.on2PI();
        madnes_audio_play('misc_Rope_Right');

    }

    /*if(this.lastSin < syn && syn > nextSyn) {
        this.onHalfPI();
    } else if(this.lastSin > syn && syn < nextSyn) {
        this.on3QPI();
    }*/

    madnes_set_pos_y(this._name, posY);

    this._lastSin = sin;
};

AnimSineBouncingY.prototype.run = function() {
    madnes_add_to_render(this.upd);
};

AnimSineBouncingY.prototype.stop = function() {
    madnes_rem_from_render(this.upd);
};